<template>
  <CustomUpdateDialog
    dialogTitle="ویرایش پکیج سوال مسابقه"
    dialogId="update-question-package-dialog"
    :isOkDisabled="isOkButtonDisabled"
    @ok="updateMatchQuestionPackage"
  >
    <BCol cols="12">
      <TextInput
        customRules="required|min:1"
        inputId="name"
        inputLabel="نام پکیج را وارد کنید"
        inputPlaceholder="سوال 20 تایی"
        v-model="updateMatchQuestionPackagePayload.name"
      ></TextInput>
    </BCol>
    <BCol cols="12">
      <TextInput
        customRules="required|min:1"
        inputId="questionCount"
        inputLabel="تعداد سوالات پکیج را وارد کنید"
        inputPlaceholder="20"
        v-model="updateMatchQuestionPackagePayload.questionCount"
      ></TextInput>
    </BCol>
    <BCol cols="12">
      <CustomDatePicker
        inputId="matchQuestionPackExpireDate"
        @getSelectedDate="setExpireDate"
        v-model="updateMatchQuestionPackagePayload.expireDate"
        inputLabel="تاریخ انقضای این پکیج"
        inputPlaceholder="1403/06/05"
      >
      </CustomDatePicker>
    </BCol>
    <BCol cols="12">
      <CustomAppendText
        readonly
        :isText="true"
        customRules="required|min:1"
        inputId="matchQuestionPackCost"
        inputLabel="قیمت پکیج"
        inputPlaceholder="100000"
        v-model="updateMatchQuestionPackagePayload.cost"
      >
        <template #append> تومان </template>
      </CustomAppendText>
    </BCol>
  </CustomUpdateDialog>
</template>
<script>
export default {
  emits: ["refetch"],
  props: {
    defaulQuestionPackageDetails: {
      type: Object,
      required: false,
    },
  },
  watch: {
    defaulQuestionPackageDetails: {
      handler(val) {
        if (val) {
          this.updateMatchQuestionPackagePayload =
            this.defaulQuestionPackageDetails;
        }
      },
    },
  },
  data() {
    return {
      updateMatchQuestionPackagePayload: {
        name: null,
        questionCount: null,
        expireDate: null,
        cost: null,
      },
      isOkButtonDisabled: false,
    };
  },
  methods: {
    setExpireDate(expireDate) {
      if (expireDate) {
        this.updateMatchQuestionPackagePayload.expireDate = new Date(
          expireDate
        ).toISOString();
      } else {
        this.updateMatchQuestionPackagePayload.expireDate = null;
      }
    },
    async updateMatchQuestionPackage() {
      try {
        this.isOkButtonDisabled = true;
        let _this = this;
        let updateMatchQuestionPackage = new UpdateMatchQuestionPackage(_this);
        updateMatchQuestionPackage.setRequestParamDataObj(
          _this.updateMatchQuestionPackagePayload
        );
        await updateMatchQuestionPackage.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "پکیج سوال های مسابقه با موفقیت ویرایش شد.",
              },
            });
            _this.updateMatchQuestionPackagePayload = {
              id: null,
              title: null,
              discountPercent: null,
              lessonIds: [],
            };
            this.$bvModal.hide("update-question-package-dialog");
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  components: {
    CustomUpdateDialog,
    CustomDatePicker,
    CustomAppendText,
    TextInput,
    BCol,
  },
};
import CustomUpdateDialog from "@/views/components/Utils/Dialogs/CustomUpdateDialog.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import CustomDatePicker from "@/views/components/Utils/CustomDatePicker.vue";
import CustomAppendText from "@/views/components/Utils/CustomAppendText.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { BCol } from "bootstrap-vue";
import { UpdateMatchQuestionPackage } from "@/libs/Api/Matches";
</script>
